/* RYZE footer signup: the BLNCO typewriter, ported 2026-07-31.
 *
 * A faux placeholder (static "Email address", a dot, and a term typed and
 * erased letter by letter) overlays the real input. The real placeholder
 * attribute stays in the markup as the no-JS truth and is cleared only once
 * this script takes over. The overlay hides the moment the field is focused
 * or holds a value. Under prefers-reduced-motion the term does not animate:
 * it swaps whole every few seconds. While the footer is off screen or the
 * tab is hidden, the timer chain idles at 800 ms instead of ticking per
 * character (same perf pattern as BLNCO's).
 */

(function () {
  'use strict';

  if (window.__ryzeNewsletterInit) return;
  window.__ryzeNewsletterInit = true;

  function initBar(bar) {
    if (bar.dataset.rnReady === '1') return;
    bar.dataset.rnReady = '1';

    var input = bar.querySelector('[data-rn-email]');
    var termEl = bar.querySelector('[data-rn-term]');
    if (!input || !termEl) return;

    var terms = (bar.getAttribute('data-rn-terms') || '')
      .split(',')
      .map(function (t) { return t.trim(); })
      .filter(Boolean);
    if (!terms.length) return;

    bar.classList.add('is-typewriter');
    input.setAttribute('placeholder', '');

    var syncActive = function () {
      var active = document.activeElement === input || input.value.length > 0;
      bar.classList.toggle('is-active', active);
    };
    input.addEventListener('focus', syncActive);
    input.addEventListener('blur', syncActive);
    input.addEventListener('input', syncActive);
    syncActive();

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var ri = 0;
      termEl.textContent = terms[0];
      if (terms.length > 1) {
        /* CODE-27 (2026-10-18): the reduced-motion rotation stops when its
           bar leaves the document (a section re-render), never runs on. */
        var rotor = window.setInterval(function () {
          if (!termEl.isConnected) { window.clearInterval(rotor); return; }
          ri = (ri + 1) % terms.length;
          termEl.textContent = terms[ri];
        }, 2600);
      }
      return;
    }

    var TYPE_MIN = 55;
    var TYPE_MAX = 95;
    var ERASE = 32;
    var HOLD = 1400;
    var GAP = 400;
    var idx = 0;
    var onScreen = true;

    /* A long phrase must be WHOLLY visible (owner order 2026-07-31). Before a
       phrase types, its full width is measured against the overlay: if the
       static "Email address" prefix would crowd it out, the prefix sits that
       cycle out (is-phrase-solo); if the phrase alone still cannot fit, the
       overlay steps its type down one notch (is-phrase-tight). Decided once
       per cycle, so nothing jumps mid-animation. Canvas measureText against
       the term's computed font; a hidden overlay measures as 0 and is skipped. */
    /* Data-attribute lookups first so any bar can host the effect (the PDP
       notify-me bar joined 2026-08-04); the footer class names stay as the
       fallback for the original markup. */
    var ph = bar.querySelector('[data-rn-ph]');
    var staticEl = ph ? ph.querySelector('[data-rn-static], .ryze-footer__signup-ph-static') : null;
    var sepEl = ph ? ph.querySelector('[data-rn-sep], .ryze-footer__signup-ph-sep') : null;
    var meas = null;
    var textWidth = function (text) {
      try {
        if (!meas) meas = document.createElement('canvas').getContext('2d');
        var cs = window.getComputedStyle(termEl);
        meas.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
        return meas.measureText(text).width;
      } catch (e) {
        return 0;
      }
    };
    var fitPhrase = function (full) {
      if (!ph || !staticEl || !sepEl) return;
      var avail = ph.clientWidth;
      if (!avail) return;
      bar.classList.remove('is-phrase-solo');
      bar.classList.remove('is-phrase-tight');
      var gapPx = 2 * 0.45 * parseFloat(window.getComputedStyle(ph).fontSize || '13');
      var prefix = staticEl.offsetWidth + sepEl.offsetWidth + gapPx;
      var caret = 4;
      var w = textWidth(full);
      if (w + prefix + caret <= avail) return;
      bar.classList.add('is-phrase-solo');
      if (w + caret <= avail) return;
      bar.classList.add('is-phrase-tight');
    };

    try {
      new IntersectionObserver(function (es) {
        for (var k = 0; k < es.length; k += 1) onScreen = es[k].isIntersecting;
      }).observe(termEl);
    } catch (e) {
      /* no observer: the chain simply always ticks */
    }

    var typeDelay = function () {
      return TYPE_MIN + Math.floor(Math.random() * (TYPE_MAX - TYPE_MIN + 1));
    };
    var typeIn = function (full, n, done) {
      if (!onScreen || document.hidden) {
        window.setTimeout(function () { typeIn(full, n, done); }, 800);
        return;
      }
      termEl.textContent = full.slice(0, n);
      if (n >= full.length) {
        window.setTimeout(done, HOLD);
        return;
      }
      window.setTimeout(function () { typeIn(full, n + 1, done); }, typeDelay());
    };
    var eraseOut = function (full, n, done) {
      if (!onScreen || document.hidden) {
        window.setTimeout(function () { eraseOut(full, n, done); }, 800);
        return;
      }
      termEl.textContent = full.slice(0, n);
      if (n <= 0) {
        window.setTimeout(done, GAP);
        return;
      }
      window.setTimeout(function () { eraseOut(full, n - 1, done); }, ERASE);
    };
    var cycle = function () {
      var full = terms[idx];
      fitPhrase(full);
      typeIn(full, 0, function () {
        eraseOut(full, full.length, function () {
          idx = (idx + 1) % terms.length;
          cycle();
        });
      });
    };
    cycle();
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(context.querySelectorAll('.ryze-footer__signup-bar, .ryze-nm-bar'), initBar);

    var form = context.querySelector ? context.querySelector('.ryze-footer__signup-form') : null;
    if (form && form.dataset.rnReady !== '1') {
      form.dataset.rnReady = '1';
      form.addEventListener('submit', function () {
        var btn = form.querySelector('[data-rn-submit]');
        if (!btn) return;
        btn.setAttribute('aria-busy', 'true');
        var label = btn.querySelector('.ryze-footer__signup-btn-text');
        if (label && !label.dataset.rnLabel) label.dataset.rnLabel = label.textContent;
        if (label) label.textContent = 'Subscribing';
      });
      /* CODE-27: a back from the confirmation restores this page from the
         bfcache mid-submit; give the button its label back. */
      window.addEventListener('pageshow', function (e) {
        if (!e.persisted) return;
        var btn = form.querySelector('[data-rn-submit]');
        if (!btn || btn.getAttribute('aria-busy') !== 'true') return;
        btn.removeAttribute('aria-busy');
        var label = btn.querySelector('.ryze-footer__signup-btn-text');
        if (label && label.dataset.rnLabel) label.textContent = label.dataset.rnLabel;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
